import { render } from "./EmpresaDadosCadastraisModal.vue?vue&type=template&id=3c2be7de&scoped=true&ts=true"
import script from "./EmpresaDadosCadastraisModal.vue?vue&type=script&lang=ts"
export * from "./EmpresaDadosCadastraisModal.vue?vue&type=script&lang=ts"

import "./EmpresaDadosCadastraisModal.vue?vue&type=style&index=0&id=3c2be7de&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2be7de"]])

export default __exports__